// extracted by mini-css-extract-plugin
export default {"wrapper":"_C-z","viewport":"aD-z","container":"bD-z","slide":"cD-z"};